import React from 'react'
import { useLocation } from 'react-router-dom'

import { getProjectName, getUserName, getScheduleTemplateName } from 'services/Utilities'
import { BreadCrumb } from 'ui'
import { t } from 'translations'

export default function BreadCrumbs() {
  const location = useLocation()
  const unavailablePath = ['/manage/users/templates', '/manage/contact/templates']

  // Generate the list of breadcrumb
  let breadcrumbs = location.pathname.replace('/manage', 'dashboard').replace('/punch/cards', '/punch').replace('/contact/lists', '/contact_lists').split('/')

  // If there are less than two breadcrumbs, don't show it (it would only contain the dashboard link which is always shown)
  if (breadcrumbs.length <= 2) return null

  // Remove the last breadcrumb if there is an extra forward slash at the end
  if (location.pathname.slice(-1) === '/') breadcrumbs.pop()

  // Remove the last item in reports if breadcrumbs.length > 3
  if (breadcrumbs.length > 3 && breadcrumbs.includes('reports')) breadcrumbs.pop()

  // We are at the root (dashboard)
  const isDashboard = location.pathname === '/manage/dashboard'
  if (isDashboard) return null

  return (
    <BreadCrumb className="px-3 py-1">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        let path = `/manage/${breadcrumbs.slice(1, index + 1).join('/')}`

        // Some links need to be changed
        if (path === '/manage/') path = '/manage/dashboard'
        if (path === '/manage/punch') path = '/manage/punch/cards'
        if (path === '/manage/punch/validation') path = '/manage/punch/cards/validation'
        if (path === '/manage/contact_lists') path = '/manage/contact/lists'
        if (path === '/manage/contact') path = '/manage/contact/lists'

        const notAvailable = unavailablePath.includes(path)

        let translation

        // Find resource names
        if (breadcrumb.length === 24) {
          const previousPath = breadcrumbs[index - 1]
          switch (previousPath) {
            case 'projects':
              translation = getProjectName(breadcrumb)
              break
            case 'users':
              translation = getUserName(breadcrumb)
              break
            case 'templates': {
              const twoPathsBefore = breadcrumbs[index - 2]
              if (twoPathsBefore === 'schedule') translation = getScheduleTemplateName(breadcrumb)
              break
            }
            default:
              break
          }
        }

        // If no translation has been found yet (no resource name)
        if (!translation) {
          translation = t(`manager.${breadcrumb.toUpperCase()}`)
          if (translation === `manager.${breadcrumb.toUpperCase()}`) translation = t('manager.breadcumbs.ACTIVE')
        }

        return (
          <BreadCrumb.Item active={Boolean(isLast)} notAvailable={notAvailable} key={index} to={path}>
            {translation}
          </BreadCrumb.Item>
        )
      })}
    </BreadCrumb>
  )
}
